"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSwitchPersonWidgets = void 0;
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const hasMoreThanOneInterviewablePerson = (interview) => odHelpers.getInterviewablePersonsArray({ interview }).length > 1;
const activePersonTitle = {
    type: 'text',
    align: 'center',
    containsHtml: true,
    classes: '',
    text: (t, interview, _path) => {
        const activePerson = odHelpers.getActivePerson({ interview });
        if (activePerson === null) {
            return '';
        }
        return t(['customSurvey:ActivePersonTitle', 'survey:ActivePersonTitle'], {
            context: activePerson.nickname === undefined ? 'unnamed' : '',
            name: activePerson.nickname || activePerson._sequence
        });
    },
    // Show if there is more than one person in the interview, even if there is only one interviewable person
    conditional: (interview) => odHelpers.countPersons({ interview }) > 1
};
const buttonSwitchPerson = {
    type: 'button',
    align: 'center',
    containsHtml: true,
    color: 'blue',
    size: 'small',
    hideWhenRefreshing: true,
    label: (t) => t(['customSurvey:SwitchPersonTitle', 'survey:SwitchPersonTitle']),
    confirmPopup: {
        // FIXME Does the popup work? It seems like the allWidgetsValid is not really verified and the action happens anyway
        // FIXME allWdigetsValid is a frontend concept, figure out a better way to handle this
        conditional: (interview) => !interview.allWidgetsValid,
        content: (t) => t(['customSurvey:SwitchPersonNeedComplete', 'survey:SwitchPersonNeedComplete']),
        showConfirmButton: false,
        cancelButtonColor: 'blue',
        cancelButtonLabel: (t) => t('main:OK')
    },
    conditional: (interview, _path) => [hasMoreThanOneInterviewablePerson(interview), undefined],
    action: function (callbacks, _interview, _path, _section, _sections, _saveCallback) {
        // FIXME: We navigate to the selectPerson section... That means this widget should be part of a feature that contains this section
        callbacks.startNavigate({ requestedSection: { sectionShortname: 'selectPerson' } });
    }
};
/**
 * For household surveys, this function provides the widget configurations to
 * switch between persons during the survey
 * @param options
 * @returns The widget configurations to switch between persons during a survey
 */
const getSwitchPersonWidgets = (
// FIXME: Type this when there is a few more widgets implemented
_options = {}) => {
    // TODO These should be some configuration receive here to fine-tune the section's content
    return {
        activePersonTitle,
        buttonSwitchPerson
    };
};
exports.getSwitchPersonWidgets = getSwitchPersonWidgets;
//# sourceMappingURL=widgetsSwitchPerson.js.map